/**
 * The draft preview for the Settings copy editor (AC-11, GDN-3230).
 *
 * The preview endpoint composes the SAVED copy — it takes only an org id, so it
 * cannot render text the admin has not saved yet. Left alone, the preview lags
 * every keystroke and an admin edits blind until they blur.
 *
 * Rather than guess how the template joins the body to the link, this reads the
 * rule out of the server's own output: the composed message is the saved body
 * followed by whatever the template appends, so the difference between them IS
 * the suffix. Applying that same suffix to the draft gives a preview that is
 * faithful by construction rather than by assumption.
 *
 * When the composed message does not start with the saved body — a template
 * that wraps rather than appends, or copy the server normalised on save — the
 * derivation returns null and the caller falls back to showing the saved
 * preview with a label saying it refreshes after saving. Guessing a separator
 * would produce a preview that looks authoritative and is not, which is worse
 * than one that is honestly out of date.
 */
export const deriveAppendedSuffix = (
  savedBody: string,
  composedBody: string,
): string | null => (composedBody.startsWith(savedBody) ? composedBody.slice(savedBody.length) : null);

export const composeDraftPreview = (
  draftBody: string,
  savedBody: string,
  composedBody: string,
): string | null => {
  const suffix = deriveAppendedSuffix(savedBody, composedBody);
  return suffix === null ? null : `${draftBody}${suffix}`;
};
